// First-party analytics tracker — sends lightweight events to our own backend.
const API = process.env.REACT_APP_BACKEND_URL;
const SID_KEY = 'avr_sid';

function sessionId() {
  let s = localStorage.getItem(SID_KEY);
  if (!s) {
    s = 'sid_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem(SID_KEY, s);
  }
  return s;
}

function source() {
  try {
    const r = document.referrer;
    if (!r) return 'Direct';
    const h = new URL(r).hostname.replace(/^www\./, '');
    if (h && window.location.hostname.includes(h)) return 'Internal';
    return h || 'Direct';
  } catch {
    return 'Direct';
  }
}

function send(payload) {
  try {
    const body = JSON.stringify({ session_id: sessionId(), ...payload });
    const url = `${API}/api/analytics/track`;
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([body], { type: 'application/json' }));
    } else {
      fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true });
    }
  } catch {
    /* analytics must never break the app */
  }
}

export const trackPageView = (path) => send({ type: 'page_view', path, referrer: source() });
export const trackProductView = (id, name) => send({ type: 'product_view', product_id: id, product_name: name });
export const trackAddToCart = (id, name) => send({ type: 'add_to_cart', product_id: id, product_name: name });
export const trackScroll = (depth, path) => send({ type: 'scroll_depth', value: depth, path });
